<template>
  <div>
    <label
      class="file-picker ui-w-full ui-flex ui-flex-row ui-items-center ui-justify-between ui-px-4 ui-cursor-pointer"
      :class="{
        'default': !small,
        'small': small,
      }"
      :style="borderStateCss"
      :to="pickerName"
    >
      <span
        class="c-text-input c-text-gray-300"
        :style="labelStateCss"
      >
        {{ fileName || label }}
      </span>
      <icon
        class="ui-transform ui-rotate-180"
        name="download"
        color="#999999"
        filled
      />
      <input
        class="ui-hidden"
        type="file"
        :name="pickerName"
        accept=".csv"
        @change="handleChange"
      >
    </label>
    <div
      class="ui-flex ui-flex-row ui-items-center ui-text-dsk-b3 ui-heading-dsk-b3 ui-mt-1 ui-font-medium ui-antialiased"
      :style="textStateCss"
      data-testid="info"
    >
      <span>
        <icon
          v-if="info.icon"
          :name="info.icon"
          class="ui-w-3 ui-mr-1"
          :color="iconStateCss"
          :filled="info.iconFilled"
          data-testid="info-icon"
        />
      </span>
      <span
        class="ui-text-xs ui-font-semibold"
        :style="textStateCss"
        data-testid="info-message"
        v-html="info.message"
      />
    </div>
  </div>
</template>

<script>
import { Icon } from '@estrategiahq/coruja-web-ui';
import {
  BORDER_STATE_COLORS,
  INFO_STATE_COLORS,
  LABEL_STATE_COLORS,
} from './constants';

export default {
  name: 'FilePicker',
  components: {
    Icon,
  },
  props: {
    pickerName: {
      type: String,
      default: 'default-file-picker-name',
    },
    label: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: 'DEFAULT',
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fileName: null,
  }),
  computed: {
    borderStateCss() {
      const color = BORDER_STATE_COLORS[this.state];
      return `box-shadow: inset 0 0 0 ${color === BORDER_STATE_COLORS.DEFAULT ? 1 : 2}px var(${color})`;
    },
    textStateCss() {
      const color = INFO_STATE_COLORS[this.state];
      return `color: var(${color})`;
    },
    iconStateCss() {
      const color = INFO_STATE_COLORS[this.state];
      return `var(${color})`;
    },
    labelStateCss() {
      const color = LABEL_STATE_COLORS[this.state];
      return `color: var(${color})`;
    },
  },
  methods: {
    handleChange(e) {
      this.fileName = e.target.value.split('\\').pop();
      this.$emit('change', e.target.files[0]);
      this.$emit('blur');
    },
  },
};
</script>

<style scoped>
.file-picker {
  box-shadow: inset 0 0 0 1px #ccc;
  border-radius: .25rem;
}

.file-picker.small {
  height: 2rem;
}

.file-picker.default {
  height: 3.5rem;
}
</style>
